import { ReactNode } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Text } from '../../../text';

type AiActivityBubbleProps = {
  text: ReactNode;
  leadingIcon?: ReactNode;
};
export const AiActivityBubble = ({ text, leadingIcon }: AiActivityBubbleProps) => {
  return (
    <div
      className='bubble-content'
      css={[
        {
          display: 'flex',
          alignItems: 'center',
          columnGap: theme.spacing(1),
          position: 'relative',
        },
        !!leadingIcon && leadingLineStyles,
      ]}
    >
      {leadingIcon}
      <Text size='small' css={{ wordBreak: 'break-word' }} className='bubble-text' color='default'>
        {text}
      </Text>
    </div>
  );
};

const leadingLineStyles = css`
  ::before {
    content: '';
    position: absolute;
    left: -${theme.spacing(1)};
    top: 50%;
    transform: translateY(-50%);
    width: 2px;
    height: ${theme.spacing(1.5)};
    background-color: ${theme.colors.neutral20};
    border-radius: ${theme.borderRadius.large};
  }
`;
